import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import dataService from "../../../../helpers/dataService";
import tools from "../../../../helpers/tools";
import Page from "../../../common/layout/Page";
import Loader from "../../../common/Loader";
import MRPForm from "./MRPForm/MRPForm";
import mrpUseFormState from "./MRPForm/useFormState";
import rcproUseFormState from "./RCPROForm/useFormState";
import RCPROForm from "./RCPROForm/RCPROForm";

const FormByProduct = {
  MRP: MRPForm,
  RCPRO: RCPROForm,
};

const ModifyAnswers = (props) => {
  var { quotationId, establishmentId, productId, clientId } =
    props.match.params;

  const hooksByProduct = {
    MRP: mrpUseFormState,
    RCPRO: rcproUseFormState,
  };

  const { actions, apiData } = hooksByProduct[productId]();
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    actions.resetFormState();
    getQuotation();
    getClient();
  }, []);

  const getQuotation = () => {
    console.log("quotationId", quotationId);
    if (quotationId) {
      setIsLoading(true);
      dataService.get(
        `quotations/${quotationId}/establishments/${establishmentId}/products/${productId}`,
        (data) => {
          dataService.get(`clients/${clientId}`, (cdata) => {
            actions.initFormState({
              ...data,
              headOfficeTurnover: cdata.turnover,
              headOfficeWorkforce: cdata.workforce,
              headOfficeLegalForm: cdata.legalForm?.id,
              headOfficeCsp: cdata.socioProfessionalCategory,
              establishmentId,
              quotationId,
            });
          });
        },
        (err) =>
          setErrors(
            "Erreur lors de la récupération des données. Veuillez recharger la page. Si le problème persiste, contactez Perceval"
          ),
        () => setIsLoading(false)
      );
    }
  };

  const getClient = () => {};

  console.log("apiData", apiData);

  const FormComponent = FormByProduct[productId];

  const productIcon = productId === "MRP" ? "fa-store" : "fa-umbrella";

  return (
    <Page
      title={`Modifier les réponses ${productId}`}
      back={`/forms/${clientId}`}
      backText="Retour"
      margin="my-3"
    >
      {isLoading ? (
        <Loader size={70} />
      ) : errors ? (
        <div className="alert alert-danger">{errors}</div>
      ) : (
        <>
          {apiData && (
            <h4 className="pb-2 pt-3">
              <i className={`fa ${productIcon} mr-2`} />
              {apiData.name}{" "}
              <small>
                (
                {tools.formatFollowingPattern(apiData.siret, [3, 3, 3, 5], " ")}
                )
              </small>
            </h4>
          )}
          {FormComponent && <FormComponent clientId={clientId} />}
        </>
      )}
    </Page>
  );
};

export default withRouter(ModifyAnswers);
